import { defineMessages } from 'react-intl';

export default defineMessages({
    activitieslandingAssignment: {
        id: 'e1p.gateway.views.activities-landing.Assignment',
        defaultMessage: 'Assignment'
    },
    activitieslandingComplete: {
        id: 'e1p.gateway.views.activities-landing.Complete',
        defaultMessage: 'Complete'
    },
    activitieslandingCanceled: {
        id: 'e1p.gateway.views.activities-landing.Canceled',
        defaultMessage: 'Canceled'
    },
    activitieslandingCreatedBy: {
        id: 'e1p.gateway.views.activities-landing.Created By',
        defaultMessage: 'Created By'
    },
    activitieslandingLoadingActivities: {
        id: 'e1p.gateway.views.activities-landing.Loading Activities',
        defaultMessage: 'Loading Activities'
    },
    activitieslandingMe: {
        id: 'e1p.gateway.views.activities-landing.Me',
        defaultMessage: 'Me'
    },
    activitieslandingOpen: {
        id: 'e1p.gateway.views.activities-landing.Open',
        defaultMessage: 'Open'
    },
    activitieslandingOptions: {
        id: 'e1p.gateway.views.activities-landing.Options',
        defaultMessage: 'Options'
    },
    activitieslandingOthers: {
        id: 'e1p.gateway.views.activities-landing.Others',
        defaultMessage: 'Others'
    },
    activitieslandingPriority: {
        id: 'e1p.gateway.views.activities-landing.Priority',
        defaultMessage: 'Priority'
    },
    activitieslandingQuickFilters: {
        id: 'e1p.gateway.views.activities-landing.Quick Filters',
        defaultMessage: 'Quick Filters'
    },
    activitieslandingSkipped: {
        id: 'e1p.gateway.views.activities-landing.Skipped',
        defaultMessage: 'Skipped'
    },
    activitieslandingStatus: {
        id: 'e1p.gateway.views.activities-landing.Status',
        defaultMessage: 'Status'
    },
    activitieslandingCategory: {
        id: 'e1p.gateway.views.activities-landing.Category',
        defaultMessage: 'Category'
    },
    activitieslandingIcs: {
        id: 'e1p.gateway.views.activities-landing.ICS',
        defaultMessage: 'ICS'
    },
    activitieslandingIcsUw: {
        id: 'e1p.gateway.views.activities-landing.ICS UW',
        defaultMessage: 'ICS UW'
    },
    activitieslandingSwitchto: {
        id: 'e1p.gateway.views.activities-landing.Switch to',
        defaultMessage: 'Switch to'
    },
    activitieslandingToMe: {
        id: 'e1p.gateway.views.activities-landing.To Me',
        defaultMessage: 'To Me'
    },
    activitieslandingToOthers: {
        id: 'e1p.gateway.views.activities-landing.To Others',
        defaultMessage: 'To Others'
    },
    activitieslandingType: {
        id: 'e1p.gateway.views.activities-landing.Type',
        defaultMessage: 'Type'
    },
    activitieslandingClearAll: {
        id: 'e1p.gateway.views.filters.Clear All',
        defaultMessage: 'Clear All'
    },
    activitieslandingClearAllFilters: {
        id: 'e1p.gateway.views.filters.Clear All Filters',
        defaultMessage: 'Clear All Filters'
    },
    activitieslandingSelectAll: {
        id: 'e1p.gateway.views.filters.Select All',
        defaultMessage: 'Select All'
    }
});
